import { ACTIVE_STATE_ACTIVE, ACTIVE_STATE_INACTIVE } from 'src/util/constants';
import isActive from 'src/util/isActive';

/**
 * Determines whether an entity matches the given active state filter.
 * @param {object} entity - An entity with an `active` field containing `{start, finish}`.
 * @param {ACTIVE_STATE_ACTIVE | ACTIVE_STATE_INACTIVE } activeState
 * The active state filter to apply.
 * @returns {boolean} Whether the entity should be included in the filtered list.
 */
const matchesActiveState = (entity, activeState) => {
  if (!entity?.active) return false;
  const active = isActive(entity.active);

  switch (activeState) {
    case ACTIVE_STATE_ACTIVE:
      return active;
    case ACTIVE_STATE_INACTIVE:
      return !active;
    default: // LIST_FILTER_ALL
      return true;
  }
};

export default matchesActiveState;
